"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enforceValueBelongsToEnum = void 0;
const errors_1 = require("@deliverr/errors");
const ValidationError_1 = require("./ValidationError");
const valueBelongsToEnum_1 = require("./valueBelongsToEnum");
const enforceValueBelongsToEnum = (value, enumObject, enumName) => {
    if (!(0, valueBelongsToEnum_1.valueBelongsToEnum)(value, enumObject)) {
        throw new ValidationError_1.ValidationError({
            code: errors_1.SharedErrorCodes.INVALID_INPUT,
            message: `Invalid value for '${enumName}': '${value}'`,
            payload: { value, enumName },
        });
    }
    return true;
};
exports.enforceValueBelongsToEnum = enforceValueBelongsToEnum;
//# sourceMappingURL=enforceValueBelongsToEnum.js.map